export default __webpack_public_path__ + "static/Customise-8b469cd9c2b2038e1e7b587e9750b9c3.png";